<template>
  <el-dialog
    class="confirm-dialog"
    :modal="false"
    ref="confirm-dialog">
    <div slot="title">
      <slot name="title">提示</slot>
    </div>
    <div class="confirm-dialog-content">
      <div class="confirm-text">
        <slot name="text">确定要交卷吗，要不要再检查一下？</slot>
      </div>
      <div class="btn-wrapper">
        <div
          class="btn btn-orange-square"
          @click="cancel">取消</div>
        <div
          class="btn btn-blue-square"
          @click="confirm">确认</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ElDialog from '@/components/common/Dialog.vue';

export default {
  components: {
    ElDialog,
  },
  methods: {
    cancel() {
      this.$refs['confirm-dialog'].close();
      this.$emit('cancel');
    },
    confirm() {
      this.$refs['confirm-dialog'].close();
      this.$emit('confirm');
    },
    open() {
      this.$refs['confirm-dialog'].open();
    },
    close() {
      this.$refs['confirm-dialog'].close();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .confirm-dialog {
    /deep/ .el-dialog {
      margin-top: 35vh!important;
      width: 50vh!important;
      border: 2px solid $primary;
      border-radius: 24px;
      overflow: hidden;
    }
    .confirm-text {
      font-size: 2.2vh;
      font-weight: 700;
      line-height: 1.5;
      text-align: center;
      color: $primary;
    }
    .btn-wrapper {
      display: flex;
      justify-content: center;
      .btn {
        width: 12vh;
        height: 4.8vh;
        margin: 3vh 3vh 0;
      }
    }
  }
</style>
